import React, {useMemo} from "react"
import {graphicEvents} from "../../lib/graphic/GraphicEvents"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faEye} from "@fortawesome/free-solid-svg-icons"
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash"
import "./TicketRow.scss"
import { usePickerContext } from "../../picker/hooks/usePickerContext"

export function TicketRow(props) {

    const {type, id, formulas, category, selectedFormula, location, onDelete, onChangeFormula, onInputPassCode, formulaCode} = props
    const { state } = usePickerContext();

    function changeFormula(event) {
        const element = event.target
        const newFormulaValue = element.options[element.selectedIndex].value
        const formula = formulas.find(p => p.formulaCode === newFormulaValue)

        let tooltip = element.nextSibling
        if(formula.descriptif == '') {
            tooltip.style.display = "none"
        } else {
            tooltip.style.display = "inline"
        }
        tooltip.querySelector('.tooltiptext').innerHTML = formula.descriptif
        tooltip.dataset.tooltip = formula.descriptif

        if(state.otiPassCode == null) {
            let tr = element.parentElement.parentElement;
            if(formula.needPassCode == true) {
                onInputPassCode("");
            } else if(tr.nextElementSibling && tr.nextElementSibling.classList.contains("passcode")) {
                onInputPassCode(null);
            }
        }

        onChangeFormula(formula)
    }

    function copyAndClearRow(sourceRow) {
        const copiedRow = sourceRow.cloneNode(true);
        const copiedCells = copiedRow.querySelectorAll('td');
  
        copiedCells.forEach(cell => {
          cell.textContent = ''; // Or cell.innerHTML = '';
        });
  
        copiedRow.removeAttribute('id'); // Important: Remove the ID!
  
        sourceRow.insertAdjacentElement('afterend', copiedRow);
        return copiedRow;
    }

    function addPasscodeInput(row) {      
        const label = document.createElement('label');
        label.textContent = 'Code du pass : ';
        label.setAttribute('for', 'passcodeInput');
      
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('id', 'passcodeInput');
        input.setAttribute('name', 'passcode');

        input.oninput = (e) => {
            onInputPassCode(e.target.value);
        }

        row.querySelector('td:first-child').append(label);
        row.querySelector('td:first-child').append(input);
    }
      
    const ticketFormulaCode = useMemo(
        () => {
            if (selectedFormula) {
                return selectedFormula.formulaCode
            }
            if (formulaCode) {
                return formulaCode
            }
            return formulas[0].formulaCode
        },
        [selectedFormula]
    )

    function onSeeLocation() {
        switch (type) {
            case "SEAT": {
                graphicEvents.trigger("SEE_PLACE", {seatReference: id})
                break
            }
            case "PIT": {
                graphicEvents.trigger("SEE_PLACE", {pitId: id})
                break
            }
        }
    }

    return (
        <tr className={"TicketRow"}>
            <td>
                <span className={"TicketRow-categoryColor"} style={{backgroundColor: category.color, marginRight: 10}}/>
                <span>{category.name}</span>
            </td>
            <td>
                <span className={"TicketRow-seatReference"}>{location}</span>
            </td>
            <td>
                <select className={"TicketRow-formula"} value={ticketFormulaCode} onChange={changeFormula}>
                    {formulas.map((item, index) =>
                        <option key={index} value={item.formulaCode} data-desc={item.descriptif}>{item.label}</option>
                    )}
                </select>
                <div className="tooltip info_bulle_formule" id={"tooltip-" + location} style={{display: + (formulas[0].descriptif == '' || formulas[0].descriptif == undefined) ? 'none' : 'inline'}} data-tooltip={formulas[0].descriptif}> 
                    <img src="https://static.ingenie.fr/images/resa/aide.png" alt="aide" />
                    <span className="tooltiptext contenu_info_bulle" id={"desc-" + location}> {formulas[0].descriptif}
                    </span>
                </div>

                
            </td>
            <td>
                {`${selectedFormula.price}€`}
            </td>
            <td className={"TicketRow-action"}>
                <button onClick={onSeeLocation}>
                    <FontAwesomeIcon icon={faEye}/>
                </button>
            </td>
            <td>
                <button onClick={onDelete}>
                    <FontAwesomeIcon icon={faTrash}/>
                </button>
            </td>
        </tr>
    )
}